[
  {
    "id": "volvo-penta-evc",
    "system": "nmea2000",
    "tillverkare": "Volvo Penta",
    "modell": "EVC",
    "namn": "Volvo Penta EVC via gateway",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "nmea2000": { "tillverkare": 174 } }
  },
  {
    "id": "motor-nmea2000",
    "system": "nmea2000",
    "tillverkare": "Okänd",
    "modell": "Motor",
    "namn": "Motor på NMEA 2000",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "nmea2000": { "pgn": [127488, 127489] } }
  },
  {
    "id": "tankgivare-nmea2000",
    "system": "nmea2000",
    "tillverkare": "Okänd",
    "modell": "Tankgivare",
    "namn": "Tankgivare på NMEA 2000",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "nmea2000": { "pgn": [127505] } }
  },
  {
    "id": "raymarine-evolution",
    "system": "nmea2000",
    "tillverkare": "Raymarine",
    "modell": "Evolution",
    "namn": "Raymarine Evolution (EV-1, EV-2), autopiloten",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "nmea2000": { "tillverkare": 1851, "klass": 40 } }
  },
  {
    "id": "autopilot-nmea2000",
    "system": "nmea2000",
    "tillverkare": "Okänd",
    "modell": "Autopilot",
    "namn": "Autopilot på NMEA 2000",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "nmea2000": { "pgn": [127237] } }
  },
  {
    "id": "gps-nmea2000",
    "system": "nmea2000",
    "tillverkare": "Okänd",
    "modell": "GPS",
    "namn": "GPS-mottagare",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "nmea2000": { "pgn": [129025, 129026, 129029] } }
  },
  {
    "id": "kurs-nmea2000",
    "system": "nmea2000",
    "tillverkare": "Okänd",
    "modell": "Kurs och attityd",
    "namn": "Kurs- och attitydgivare",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "nmea2000": { "pgn": [127250, 127251, 127257] } }
  },
  {
    "id": "humphree",
    "system": "nmea2000",
    "tillverkare": "Humphree",
    "modell": "Interceptor",
    "namn": "Humphree, trimplanen",
    "status": "planerad",
    "vag": "officiell",
    "kanns": { "nmea2000": { "tillverkare": 1311 } }
  },
  {
    "id": "victron-nmea2000",
    "system": "nmea2000",
    "tillverkare": "Victron Energy",
    "modell": "NMEA 2000",
    "namn": "Victron på NMEA 2000",
    "status": "planerad",
    "vag": "officiell",
    "kanns": { "nmea2000": { "tillverkare": 358 } }
  },
  {
    "id": "mastervolt-nmea2000",
    "system": "nmea2000",
    "tillverkare": "Mastervolt",
    "modell": "NMEA 2000",
    "namn": "Mastervolt på NMEA 2000",
    "status": "planerad",
    "vag": "officiell",
    "kanns": { "nmea2000": { "tillverkare": 355 } }
  },
  {
    "id": "mastervolt-mli",
    "system": "masterbus",
    "tillverkare": "Mastervolt",
    "modell": "MLi Ultra",
    "namn": "Mastervolt MLi Ultra, litiumbatteriet",
    "status": "stöds",
    "vag": "egen",
    "kanns": { "masterbus": { "familj": 19 } }
  },
  {
    "id": "mastervolt-mass-combi",
    "system": "masterbus",
    "tillverkare": "Mastervolt",
    "modell": "Mass Combi",
    "namn": "Mastervolt Mass Combi, laddaren och växelriktaren",
    "status": "stöds",
    "vag": "egen",
    "kanns": { "masterbus": { "familj": 6 } }
  },
  {
    "id": "mastervolt-mass-gi",
    "system": "masterbus",
    "tillverkare": "Mastervolt",
    "modell": "Mass GI",
    "namn": "Mastervolt Mass GI, den galvaniska isolatorn",
    "status": "stöds",
    "vag": "egen",
    "kanns": { "masterbus": { "familj": 25 } }
  },
  {
    "id": "mastervolt-mac-plus",
    "system": "masterbus",
    "tillverkare": "Mastervolt",
    "modell": "Mac Plus",
    "namn": "Mastervolt Mac Plus, DC-DC",
    "status": "stöds",
    "vag": "egen",
    "kanns": { "masterbus": { "familj": 24 } }
  },
  {
    "id": "mastervolt-chargemaster",
    "system": "masterbus",
    "tillverkare": "Mastervolt",
    "modell": "ChargeMaster",
    "namn": "Mastervolt ChargeMaster, laddaren",
    "status": "stöds",
    "vag": "egen",
    "kanns": { "masterbus": { "familj": 10 } }
  },
  {
    "id": "mastervolt-granssnitt",
    "system": "masterbus",
    "tillverkare": "Mastervolt",
    "modell": "MasterBus-gränssnitt",
    "namn": "Mastervolt, gränssnittet för signaler",
    "status": "stöds",
    "vag": "egen",
    "kanns": { "masterbus": { "familj": 14 } }
  },
  {
    "id": "mastervolt-easyview",
    "system": "masterbus",
    "tillverkare": "Mastervolt",
    "modell": "EasyView 5",
    "namn": "Mastervolt EasyView 5, displayen",
    "status": "stöds",
    "vag": "egen",
    "kanns": { "masterbus": { "familj": 20 } }
  },
  {
    "id": "ecowitt-ha",
    "system": "ecowitt_ha",
    "tillverkare": "Ecowitt",
    "modell": "via Home Assistant",
    "namn": "Ecowitt via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "ecowitt" } },
    "vaderstation": true,
    "kopplas": ["vatten"]
  },
  {
    "id": "ha-airzone",
    "system": "home_assistant",
    "tillverkare": "Airzone",
    "modell": "Zoner och termostater",
    "namn": "Airzone via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "airzone|airzone_cloud", "formaga": true } }
  },
  {
    "id": "ha-shelly",
    "system": "home_assistant",
    "tillverkare": "Shelly",
    "modell": "Shelly",
    "namn": "Shelly via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "shelly", "formaga": true } }
  },
  {
    "id": "ha-shelly-andra",
    "system": "home_assistant",
    "tillverkare": "Shelly",
    "modell": "Shelly via Matter, HomeKit, Zigbee eller MQTT",
    "namn": "Shelly via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "matter|homekit_controller|zha|mqtt|esphome",
        "tillverkare": "^(Shelly|Allterco)",
        "formaga": true
      }
    }
  },
  {
    "id": "ha-shelly-em",
    "system": "home_assistant",
    "tillverkare": "Shelly",
    "modell": "Shelly EM",
    "namn": "Shelly EM via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "shelly", "modell": "\\b(3EM|EM)\\b", "formaga": true } },
    "elmatare": true
  },
  {
    "id": "ha-nuki",
    "system": "home_assistant",
    "tillverkare": "Nuki",
    "modell": "Smart Lock",
    "namn": "Nuki via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "nuki", "formaga": true } }
  },
  {
    "id": "ha-verisure",
    "system": "home_assistant",
    "tillverkare": "Verisure",
    "modell": "Larmet",
    "namn": "Verisure via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "verisure", "formaga": true } },
    "larmkalla": "larmsystem"
  },
  {
    "id": "ha-eve",
    "system": "home_assistant",
    "tillverkare": "Eve",
    "modell": "Eve",
    "namn": "Eve via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": { "integration": "homekit_controller|matter", "tillverkare": "^Eve", "formaga": true }
    }
  },
  {
    "id": "ha-eve-weather",
    "system": "home_assistant",
    "tillverkare": "Eve",
    "modell": "Eve Weather",
    "namn": "Eve Weather via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "homekit_controller|matter",
        "tillverkare": "^Eve",
        "modell": "Weather",
        "formaga": true
      }
    },
    "ute": true,
    "vaderstation": true
  },
  {
    "id": "ha-sonoff",
    "system": "home_assistant",
    "tillverkare": "SONOFF",
    "modell": "SONOFF",
    "namn": "SONOFF via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "sonoff|ewelink", "formaga": true } }
  },
  {
    "id": "ha-sonoff-zigbee",
    "system": "home_assistant",
    "tillverkare": "SONOFF",
    "modell": "SONOFF via Zigbee",
    "namn": "SONOFF via Zigbee i Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "zha|mqtt", "tillverkare": "^SONOFF", "formaga": true } }
  },
  {
    "id": "ha-zha",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Zigbee (ZHA)",
    "namn": "Zigbee (ZHA) via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "zha", "formaga": true } }
  },
  {
    "id": "ha-zigbee2mqtt",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Zigbee (zigbee2mqtt)",
    "namn": "Zigbee (zigbee2mqtt) via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "mqtt", "formaga": true } }
  },
  {
    "id": "ha-nibe",
    "system": "home_assistant",
    "tillverkare": "NIBE",
    "modell": "Värmepump",
    "namn": "NIBE via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "nibe_heatpump|myuplink|nibe_uplink", "formaga": true } }
  },
  {
    "id": "ha-swegon",
    "system": "home_assistant",
    "tillverkare": "Swegon",
    "modell": "Ventilation",
    "namn": "Swegon via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "*", "tillverkare": "^Swegon", "formaga": true } }
  },
  {
    "id": "ha-yale",
    "system": "home_assistant",
    "tillverkare": "Yale",
    "modell": "Lås",
    "namn": "Yale via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "yale|august|yalexs_ble", "formaga": true } }
  },
  {
    "id": "ha-yale-larm",
    "system": "home_assistant",
    "tillverkare": "Yale",
    "modell": "Smart Alarm",
    "namn": "Yale Smart Alarm via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "yale_smart_alarm", "formaga": true } },
    "larmkalla": "larmsystem"
  },
  {
    "id": "ha-larmsystem",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Larmsystem",
    "namn": "Larmsystem via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "ajax|alarmo|securitas_direct|securitas|risco|satel_integra|elkm1|envisalink|totalconnect|simplisafe|abode|ness_alarm|concord232|nx584|egardia|ialarm|jablotron100|hikvision_axpro|texecom|paradox_alarm|spc|point",
        "formaga": true
      }
    },
    "larmkalla": "larmsystem"
  },
  {
    "id": "ha-kamera",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Kamerasystem",
    "namn": "Kamerasystem via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "arlo|aarlo|ring|blink|eufy_security|eufy|reolink|unifiprotect|hikvision|dahua|amcrest|tapo_control|wyze|frigate",
        "formaga": true
      }
    },
    "larmkalla": "kamera"
  },
  {
    "id": "ha-ikea",
    "system": "home_assistant",
    "tillverkare": "IKEA",
    "modell": "IKEA",
    "namn": "IKEA via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "tradfri|dirigera_platform", "formaga": true } }
  },
  {
    "id": "ha-ikea-zigbee",
    "system": "home_assistant",
    "tillverkare": "IKEA",
    "modell": "IKEA via Zigbee",
    "namn": "IKEA via Zigbee i Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "zha|mqtt", "tillverkare": "^IKEA", "formaga": true } }
  },
  {
    "id": "ha-nobo",
    "system": "home_assistant",
    "tillverkare": "Nobø",
    "modell": "Nobø Hub",
    "namn": "Nobø via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "nobo_hub", "formaga": true } }
  },
  {
    "id": "ha-hue",
    "system": "home_assistant",
    "tillverkare": "Signify",
    "modell": "Philips Hue",
    "namn": "Philips Hue via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "hue", "formaga": true } }
  },
  {
    "id": "ha-tplink",
    "system": "home_assistant",
    "tillverkare": "TP-Link",
    "modell": "Kasa och Tapo",
    "namn": "TP-Link via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "tplink|tplink_tapo", "formaga": true } }
  },
  {
    "id": "ha-tuya",
    "system": "home_assistant",
    "tillverkare": "Tuya",
    "modell": "Tuya",
    "namn": "Tuya via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "tuya", "formaga": true } }
  },
  {
    "id": "ha-netatmo",
    "system": "home_assistant",
    "tillverkare": "Netatmo",
    "modell": "Netatmo",
    "namn": "Netatmo via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "netatmo", "formaga": true } }
  },
  {
    "id": "ha-elmatare",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Elmätare",
    "namn": "Elmätare via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "dsmr|dsmr_reader|p1_monitor|slimmelezer|iotawatt|emporia_vue|sense|smappee|efergy|rainforest_eagle|rainforest_raven|amshan|tibber",
        "formaga": true
      }
    },
    "elmatare": true
  },
  {
    "id": "ha-homewizard-p1",
    "system": "home_assistant",
    "tillverkare": "HomeWizard",
    "modell": "P1 och kWh-mätare",
    "namn": "HomeWizard via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "homewizard", "modell": "P1|SDM|kWh|KWH", "formaga": true } },
    "elmatare": true
  },
  {
    "id": "ha-vaderstation",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Väderstation",
    "namn": "Väderstation via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "weatherflow|weatherflow_cloud|ambient_station|ambient_network|meteobridge|davis_vantage",
        "formaga": true
      }
    },
    "ute": true,
    "vaderstation": true
  },
  {
    "id": "ha-netatmo-ute",
    "system": "home_assistant",
    "tillverkare": "Netatmo",
    "modell": "Utegivaren",
    "namn": "Netatmos utegivare via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "netatmo",
        "modell": "Outdoor|NAModule[123]|Rain|Wind",
        "formaga": true
      }
    },
    "ute": true,
    "vaderstation": true
  },
  {
    "id": "ha-netatmo-station",
    "system": "home_assistant",
    "tillverkare": "Netatmo",
    "modell": "Väderstationen",
    "namn": "Netatmos väderstation via Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "netatmo",
        "modell": "NAMain|Weather Station|Smart Home Weather",
        "formaga": true
      }
    },
    "vaderstation": true
  },
  {
    "id": "ha-enhet",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Enhet i Home Assistant",
    "namn": "Enhet i Home Assistant",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "*", "formaga": true } }
  },
  {
    "id": "ha-media",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Media",
    "namn": "Media via Home Assistant",
    "status": "känd",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "cast|sonos|bluesound|linkplay|webostv|samsungtv|apple_tv|androidtv|androidtv_remote|braviatv|philips_js|roku|denonavr|heos|yamaha_musiccast|squeezebox|kodi|plex|jellyfin|dlna_dmr|dlna_dms|spotify|soundtouch|onkyo|songpal|bang_olufsen|frontier_silicon|mpd|snapcast|vizio|lg_soundbar|music_assistant|russound_rio|arcam_fmj|nad|xbox|playstation_network"
      }
    }
  },
  {
    "id": "ha-skrivare",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Skrivare",
    "namn": "Skrivare via Home Assistant",
    "status": "känd",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "ipp|brother|cups|syncthru|epson" } }
  },
  {
    "id": "ha-natverk",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Nätverk",
    "namn": "Nätverk och tjänster via Home Assistant",
    "status": "känd",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "unifi|unifiprotect|fritz|fritzbox_callmonitor|asuswrt|netgear|tplink_omada|mikrotik|synology_dsm|qnap|speedtestdotnet|upnp|ping|nmap_tracker|devolo_home_network|huawei_lte|keenetic_ndms2|tailscale|glances|system_monitor|pi_hole|adguard"
      }
    }
  },
  {
    "id": "ha-hushall",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Hushållet",
    "namn": "Hushållsmaskiner via Home Assistant",
    "status": "känd",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "home_connect|miele|lg_thinq|whirlpool|electrolux_status|roborock|ecovacs|neato"
      }
    }
  },
  {
    "id": "fast-skarm",
    "system": "home_assistant",
    "tillverkare": "Okänd",
    "modell": "Fast skärm",
    "namn": "Fast skärm",
    "status": "känd",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "*", "klass": "fast_skarm" } }
  },
  {
    "id": "ruuvitag",
    "system": "ruuvi",
    "tillverkare": "Ruuvi",
    "modell": "RuuviTag",
    "namn": "RuuviTag",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "ruuvi", "modell": "^RuuviTag$" } }
  },
  {
    "id": "ruuvitag-pro",
    "system": "ruuvi",
    "tillverkare": "Ruuvi",
    "modell": "RuuviTag Pro",
    "namn": "RuuviTag Pro",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "ruuvi", "modell": "^RuuviTag Pro" } }
  },
  {
    "id": "shelly-blu-ht",
    "system": "bthome",
    "tillverkare": "Shelly",
    "modell": "BLU H&T",
    "namn": "Shelly BLU H&T",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "bthome", "modell": "^Shelly BLU H&T" } }
  },
  {
    "id": "shelly-ws90",
    "system": "bthome",
    "tillverkare": "Shelly",
    "modell": "WS90",
    "namn": "Shelly WS90, väderstationen",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "bthome", "modell": "WS90" } }
  },
  {
    "id": "xiaomi-pvvx",
    "system": "bthome",
    "tillverkare": "Xiaomi",
    "modell": "LYWSD03MMC",
    "namn": "Xiaomi LYWSD03MMC (pvvx)",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "bthome", "modell": "^Xiaomi" } }
  },
  {
    "id": "bthome-givare",
    "system": "bthome",
    "tillverkare": "Okänd",
    "modell": "BTHome",
    "namn": "Givare med BTHome",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "bthome" } }
  },
  {
    "id": "inkbird-ibs-th2",
    "system": "inkbird",
    "tillverkare": "Inkbird",
    "modell": "IBS-TH2",
    "namn": "Inkbird IBS-TH2",
    "status": "beta",
    "vag": "egen",
    "kanns": { "bluetooth": { "sort": "inkbird", "modell": "^IBS-TH2" } }
  },
  {
    "id": "ecowitt-gw2000",
    "system": "ecowitt",
    "tillverkare": "Ecowitt",
    "modell": "GW2000",
    "namn": "Ecowitt GW2000",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ecowitt": { "modell": "^GW2000" } }
  },
  {
    "id": "ecowitt-gw1100",
    "system": "ecowitt",
    "tillverkare": "Ecowitt",
    "modell": "GW1100",
    "namn": "Ecowitt GW1100",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "ecowitt": { "modell": "^GW1100" } }
  },
  {
    "id": "ecowitt-gw1200",
    "system": "ecowitt",
    "tillverkare": "Ecowitt",
    "modell": "GW1200",
    "namn": "Ecowitt GW1200",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "ecowitt": { "modell": "^GW1200" } }
  },
  {
    "id": "ecowitt-wh51",
    "system": "ecowitt",
    "tillverkare": "Ecowitt",
    "modell": "WH51",
    "namn": "Ecowitt WH51",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ecowitt": { "modell": "^WH51$" } }
  },
  {
    "id": "ecowitt-wh51-ha",
    "system": "ecowitt_ha",
    "tillverkare": "Ecowitt",
    "modell": "WH51",
    "namn": "Ecowitt WH51",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ecowitt": { "modell": "^WH51$", "via": "ha" } }
  },
  {
    "id": "nobo-hub",
    "system": "nobo",
    "tillverkare": "Nobø",
    "modell": "Hub",
    "namn": "Nobø Hub",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "nobo": true }
  },
  {
    "id": "whisper-power-8",
    "system": "forbrukare",
    "tillverkare": "Whisper Power",
    "modell": "8",
    "namn": "Whisper Power 8, generatorn",
    "status": "beta",
    "vag": "egen",
    "forbrukare": { "sort": "generator", "lh": 2 }
  },
  {
    "id": "eberspacher-5dl",
    "system": "forbrukare",
    "tillverkare": "Eberspächer",
    "modell": "5DL",
    "namn": "Eberspächer 5DL, värmaren",
    "status": "beta",
    "vag": "egen",
    "forbrukare": { "sort": "varmare", "lh": 0.4 }
  },
  {
    "id": "victron-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "GX",
    "namn": "Victron GX-enhet",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "gx" } }
  },
  {
    "id": "victron-cerbo-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "Cerbo GX",
    "namn": "Victron Cerbo GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "gx", "produkt": "Cerbo" } }
  },
  {
    "id": "victron-batteri-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "Batteriövervakare",
    "namn": "Victron batteriövervakare via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "battery" } }
  },
  {
    "id": "victron-smartshunt-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "SmartShunt",
    "namn": "Victron SmartShunt via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "battery", "produkt": "SmartShunt" } }
  },
  {
    "id": "victron-bmv712-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "BMV-712",
    "namn": "Victron BMV-712 via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "battery", "produkt": "BMV-?712" } }
  },
  {
    "id": "victron-lynx-bms-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "Lynx Smart BMS",
    "namn": "Victron Lynx Smart BMS via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "battery", "produkt": "Lynx Smart BMS" } }
  },
  {
    "id": "victron-mppt-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "SmartSolar MPPT",
    "namn": "Victron SmartSolar MPPT via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "solarcharger" } }
  },
  {
    "id": "victron-multiplus-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "MultiPlus eller Quattro",
    "namn": "Victron MultiPlus eller Quattro via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "vebus" } }
  },
  {
    "id": "victron-orion-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "Orion-Tr Smart",
    "namn": "Victron Orion-Tr Smart via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "dcdc" } }
  },
  {
    "id": "victron-tank-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "Tankgivare",
    "namn": "Victron tankgivare via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "tank" } }
  },
  {
    "id": "victron-temp-gx",
    "system": "victron_gx",
    "tillverkare": "Victron Energy",
    "modell": "Temperaturgivare",
    "namn": "Victron temperaturgivare via GX",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "victron": { "tjanst": "temperature" } }
  },
  {
    "id": "victron-ble",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "Instant Readout",
    "namn": "Victron över Bluetooth",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron" } }
  },
  {
    "id": "victron-smartshunt",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "SmartShunt",
    "namn": "Victron SmartShunt",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron", "modell": "^SmartShunt" } }
  },
  {
    "id": "victron-bmv712",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "BMV-712",
    "namn": "Victron BMV-712 Smart",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron", "modell": "^BMV" } }
  },
  {
    "id": "victron-mppt",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "SmartSolar MPPT",
    "namn": "Victron SmartSolar MPPT",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron", "modell": "^SmartSolar" } }
  },
  {
    "id": "victron-orion",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "Orion-Tr Smart",
    "namn": "Victron Orion-Tr Smart",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron", "modell": "^Orion" } }
  },
  {
    "id": "victron-smartlithium",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "Smart Lithium",
    "namn": "Victron Smart Lithium",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron", "modell": "^Smart Lithium" } }
  },
  {
    "id": "victron-lynx-bms",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "Lynx Smart BMS",
    "namn": "Victron Lynx Smart BMS",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron", "modell": "^Lynx Smart BMS" } }
  },
  {
    "id": "victron-phoenix",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "Phoenix Smart",
    "namn": "Victron Phoenix Smart, växelriktaren",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron", "modell": "^Phoenix" } }
  },
  {
    "id": "victron-bluesmart",
    "system": "victron_ble",
    "tillverkare": "Victron Energy",
    "modell": "Blue Smart",
    "namn": "Victron Blue Smart, laddaren för 230 V",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "bluetooth": { "sort": "victron", "modell": "^Blue Smart" } }
  },
  {
    "id": "varmare-utblas",
    "system": "forbrukare",
    "tillverkare": "Valfri",
    "modell": "Givare vid utblåset",
    "namn": "Temperaturen vid utblåset, till exempel en RuuviTag",
    "status": "beta",
    "vag": "egen"
  },
  {
    "id": "homey-pro",
    "system": "homey",
    "tillverkare": "Athom",
    "modell": "Homey Pro",
    "namn": "Homey Pro",
    "status": "beta",
    "vag": "officiell"
  },
  {
    "id": "shelly-lokalt",
    "system": "shelly",
    "tillverkare": "Shelly",
    "modell": "Plus och Pro",
    "namn": "Shelly Plus och Pro, med det lokala API:et",
    "status": "planerad",
    "vag": "officiell"
  },
  {
    "id": "matter-enhet",
    "system": "matter",
    "tillverkare": "Okänd",
    "modell": "Matter",
    "namn": "Enhet med Matter",
    "status": "planerad",
    "vag": "officiell"
  },
  {
    "id": "knx-ip",
    "system": "knx",
    "tillverkare": "Okänd",
    "modell": "KNX IP",
    "namn": "KNX, IP-gränssnittet",
    "status": "planerad",
    "vag": "officiell"
  },
  {
    "id": "polestar",
    "system": "fordon",
    "tillverkare": "Polestar",
    "modell": "Polestar",
    "namn": "Polestar",
    "status": "planerad",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "*", "tillverkare": "^Polestar" } }
  },
  {
    "id": "fordon-ha",
    "system": "fordon",
    "tillverkare": "Okänd",
    "modell": "Bil",
    "namn": "Bil via Home Assistant",
    "status": "planerad",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "polestar_api|tesla_fleet|teslemetry|tessie|volvo|volvooncall|bmw_connected_drive|renault|kia_uvo|mercedes_me|audi_connect|volkswagencarnet|nissan_leaf|peugeot_connect|skodaconnect|ford|toyota|subaru|mazda|hyundai"
      }
    }
  },
  {
    "id": "homey-enhet",
    "system": "homey",
    "tillverkare": "Okänd",
    "modell": "Enhet i Homey",
    "namn": "Enhet i Homey",
    "status": "beta",
    "vag": "officiell",
    "kanns": { "homey": { "formaga": true } }
  },
  {
    "id": "homey-media",
    "system": "homey",
    "tillverkare": "Okänd",
    "modell": "Media",
    "namn": "Media i Homey",
    "status": "känd",
    "vag": "officiell",
    "kanns": {
      "homey": { "klass": "^(speaker|tv|amplifier|remote|camera|doorbell|vacuumcleaner)$" }
    }
  },
  {
    "id": "onwa-kw360",
    "system": "vader_bat",
    "tillverkare": "Onwa",
    "modell": "KW-360",
    "namn": "Onwa KW-360, väderstation för båt (RS-485 med Modbus eller NMEA 0183)",
    "status": "planerad",
    "vag": "officiell",
    "ute": true,
    "vaderstation": true
  },
  {
    "id": "onwa-kw360-mini",
    "system": "vader_bat",
    "tillverkare": "Onwa",
    "modell": "KW-360 mini",
    "namn": "Onwa KW-360 mini, väderstation för båt (RS-485 med Modbus eller NMEA 0183)",
    "status": "planerad",
    "vag": "officiell",
    "ute": true,
    "vaderstation": true
  },
  {
    "id": "teltonika-rutx50",
    "system": "teltonika",
    "tillverkare": "Teltonika",
    "modell": "RUTX50",
    "namn": "Teltonika RUTX50, router med position (NMEA 0183 över nätet)",
    "status": "planerad",
    "vag": "officiell"
  },
  {
    "id": "shelly-blu-door-window",
    "system": "bthome",
    "tillverkare": "Shelly",
    "modell": "BLU Door/Window",
    "namn": "Shelly BLU Door/Window, för ingångsluckan (BTHome)",
    "status": "planerad",
    "vag": "officiell"
  },
  {
    "id": "lenovo-idea-tab-pro",
    "system": "home_assistant",
    "tillverkare": "Lenovo",
    "modell": "Idea Tab Pro (TB373FU)",
    "namn": "Lenovo Idea Tab Pro (TB373FU), surfplatta",
    "status": "känd",
    "vag": "officiell",
    "kanns": {
      "ha": {
        "integration": "mobile_app|fully_kiosk|browser_mod",
        "tillverkare": "^lenovo",
        "modell": "^TB373F",
        "klass": "fast_skarm"
      }
    }
  },
  {
    "id": "innomaker-usb-can",
    "system": "masterbus",
    "tillverkare": "Innomaker",
    "modell": "USB-CAN (gs_usb)",
    "namn": "Innomaker USB-CAN, navets adapter för MasterBus (ingen enhet ombord)",
    "status": "känd",
    "vag": "officiell"
  },
  {
    "id": "dormakaba-dkey",
    "system": "home_assistant",
    "tillverkare": "dormakaba",
    "modell": "dKey (MTL 9291)",
    "namn": "dormakaba dKey",
    "status": "prov",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "dormakaba_dkey" } }
  },
  {
    "id": "esphome-ble-proxy",
    "system": "home_assistant",
    "tillverkare": "evatek",
    "modell": "ble-proxy",
    "namn": "ESPHome Bluetooth-proxy, hjälpmedel för låset (ingen enhet att bevaka)",
    "status": "känd",
    "vag": "officiell",
    "kanns": {
      "ha": { "integration": "esphome", "tillverkare": "^evatek$", "modell": "^ble-proxy" }
    }
  },
  {
    "id": "ha-knx-termostat",
    "system": "home_assistant",
    "tillverkare": "KNX",
    "modell": "Termostater",
    "namn": "KNX-termostater",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "knx", "formaga": true } }
  },
  {
    "id": "ha-termostat-yaml",
    "system": "home_assistant",
    "tillverkare": "Home Assistant",
    "modell": "Termostat utan enhet",
    "namn": "Termostat utan enhet",
    "status": "stöds",
    "vag": "officiell",
    "kanns": { "ha": { "integration": "yaml", "formaga": true } }
  }
]
